import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { shopTarifierungPH } from './shopTarifierungPH';
import { watchInDashboardUebernehmenSaga } from './inDashboardUebernehmenSaga';
import { streckenTarifierungPH } from './streckenTarifierungPH';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchVersicherungssummen } from './versicherungssummenSaga';
import { watchVorschlagdatenChanged } from './vorschlagdatenSaga';
import { watchAntragsnummerRequested } from './antragsnummerSaga';
import { watchproduktlinienSaga } from './produktlinienSaga';
import { watchDruckdatenChanged } from './druckdatenSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchStreckeSnapshot } from './streckeSnapshotSaga';
import { watchVorbelegungRequested } from './vorbelegungSaga';
import { updateRisikoortAfterLoadAzamSaga } from './updateRisikoortAfterLoadAzamSaga';
import { handlePhNavigationToAngebotSaga } from './handlePhNavigationToAngebotSaga';

export function* rootSaga() {
  yield all([
    shopTarifierungPH(),
    watchInDashboardUebernehmenSaga(),
    streckenTarifierungPH(),
    watchVorbelegungRequested(),
    watchStateSnapshot(),
    watchStreckeSnapshot(),
    watchVersicherungssummen(),
    watchVorschlagdatenChanged(),
    watchAntragsnummerRequested(),
    watchproduktlinienSaga(),
    watchDruckdatenChanged(),
    watchQuoteDB(),
    updateRisikoortAfterLoadAzamSaga(),
    handlePhNavigationToAngebotSaga(),
  ]);
}
